import { createFileRoute } from '@tanstack/react-router';

import { DashboardPage } from '@/features/dashboard/dashboard-page';

// Dashboard home — role-aware:
// - Owner (Felipe): "Dashboard general" + selector de ejecutivo +
//   distribución por cartera (todas).
// - Member/admin (Santiago, Olga, Javiera): "Mi cartera" con métricas
//   y listado scoped al usuario logueado.
//
// Backend hace el filtering server-side via /v1/dashboard/portfolio:
// el owner manda ?executiveId= opcional; los members lo ignoran y el
// service fuerza al userId del JWT.
export const Route = createFileRoute('/_app/')({
  component: DashboardPage,
});
